import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledPageLayoutBackground = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
